<template>
    <div>
        <div class="columns toolbar-box action-right">
            <div class="column is-3">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Services Overview Report</span>
                    </span>
                </h1>
            </div>

            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-select v-model="filters.team_id" placeholder="Select Team" expanded>
                        <option value="">All teams</option>
                        <option v-for="team in teams" :value="team.id" :key="team.id">
                           {{ team.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <datepicker v-model="filters.from"
                                input-class="input is-fullwidth"
                                placeholder="Week ending from" :absolute="true"
                    />
                </div>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <datepicker v-model="filters.to"
                            input-class="input is-fullwidth"
                            placeholder="Week ending to" :absolute="true"
                />
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <o-checkbox v-model="filters.allDates">Include empty dates</o-checkbox>
                </div>
            </div>
        </div>
        <div class="columns toolbar-box action-right">
            <div class="column is-4-tablet is-2-desktop is-offset-3">
                <div class="field">
                    <datepicker v-model="filters.converted_from"
                                input-class="input is-fullwidth"
                                placeholder="Converted from" :absolute="true"
                    />
                </div>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <datepicker v-model="filters.converted_to"
                            input-class="input is-fullwidth"
                            placeholder="Converted to" :absolute="true"
                />
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <multicomplete field-name="name" v-model="projects" type="project" placeholder="Projects" />
                </div>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <o-checkbox v-model="filters.viewAll">View All</o-checkbox>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-1-desktop">&nbsp;</div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <multicomplete field-name="title" v-model="exclude_services" type="service" placeholder="Exclude Services" />
                </div>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <multicomplete field-name="title" v-model="services" type="service" placeholder="Services" />
                </div>
            </div>

            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <multicomplete field-name="full_name" v-model="users" :limit="users.length" type="user" placeholder="Project manager" />
                </div>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <multicomplete field-name="full_name" v-model="serviceUsers" :limit="users.length" type="user" placeholder="Assigned To" />
                </div>
            </div>

            <div class="column is-2 action-box">
                <div class="field">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                </div>
            </div>
        </div>

        <services-overview class="services-overview" :filters="filters" />
    </div>
</template>

<script>
    import Datepicker from './../../../components/Datepicker'
    import Table from './../../../mixins/Table'
    import ServicesOverview from './services-overview/ServicesOverview'
    import { mapGetters } from 'vuex'
    import qs from 'query-string'

    export default {
        mixins: [Table],

        components: {
            Datepicker,
            ServicesOverview,
        },

        computed: {
            ...mapGetters([
                'workTypeNamesByIds',
                'boroughNameById',
                'teamNameById',
                'teams'
            ]),
        },

        data() {
            return {
                totalExpenses: null,
                urlFilter: { enabled: false },
                isTableSettingsModalActive: false,

                table: {
                    paginated: false,
                },

                filters: {
                    allDates: true,
                    converted_from: null,
                    converted_to: null,
                    exclude_services: [],
                    from: null,
                    projects: [],
                    team_id: null,
                    to: null,
                    services: [],
                    serviceUsers: [],
                    users: [],
                    viewAll: false,
                },

                users: [],
                serviceUsers: [],
                services: [],
                projects: [],
                exclude_services: [],
                items: []
            }
        },

        mounted() {
        },

        watch: {
            'filters.users'(v) { if (v.length === 0 && this.users.length) this.users = [] },
            'filters.serviceUsers'(v) { if (v.length === 0 && this.serviceUsers.length) this.serviceUsers = [] },
            'filters.services'(v) { if (v.length === 0 && this.services.length) this.services = [] },
            'filters.projects'(v) { if (v.length === 0 && this.projects.length) this.projects = [] },
            'filters.exclude_services'(v) { if (v.length === 0 && this.exclude_services.length) this.exclude_services = [] },

            users(value) { this.filters.users = value },
            serviceUsers(value) { this.filters.serviceUsers = value },
            services(value) { this.filters.services = value },
            exclude_services(value) { this.filters.exclude_services = value },
            projects(value) { this.filters.projects = value }
        },
    }
</script>

<style lang="sass">
.services-overview
  margin-bottom: 35px
  margin-top: 35px
  .modal .animation-content
    height: 100%
    padding-top: 64px
    width: 100%
</style>